<template>
    <div class="preparation-order-delivery">
        <div class="row">
            <div class="col-lg-6 mb-3">
                <PreparationOrderContainers
                    :order="order"
                    :containers-types="containersTypes"
                    :products-by-main-category="productsByMainCategory"
                    :read-only="!order.ready_to_prepare"
                />
            </div>
            <div class="col-lg-6 mb-3">
                <div v-if="order.has_prepared_products_to_remove" class="alert alert-danger">
                    <div class="alert-heading h2">Attention, la commande a changé !</div>
                    Cette commande contient des produits préparés qui n'ont pas été commandés ou offerts !<br>
                    Les produits préparés non commandés doivent être retirés pour permettre l'impression du BL et terminer la préparation de la commande.
                </div>
                <PreparationOrderDeliveryNote
                    v-else
                    :order="order"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import ErrorsZone from "../ErrorsZone";
    import PreparationOrderContainers from "./PreparationOrderContainers"
    import PreparationOrderDeliveryNote from "./PreparationOrderDeliveryNote"
    import {orderReady} from "../../orders-utils";

    export default {
        name: 'PreparationOrderDelivery',

        components: {
            ErrorsZone,
            PreparationOrderContainers,
            PreparationOrderDeliveryNote
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
            containersTypes: {
                type: Array,
                required: true,
            },
            productsByMainCategory: {
                type: Array,
                required: true,
            },
        },

        setup() {
            return {};
        },


        data() {
            return {};
        },

        methods: {},

        computed: {
            orderReady,
        },
    }
</script>
